<template>

  <div class="wrapper">

    <!-- <h2>How others work it</h2> -->
    <h2>Check out how you could #learnwithhato and create something great</h2>
    <div class="listings">

      <div class="listing" v-for="ig in instagrams.slice(0,8)" :key="ig.url">
        <a :href="ig.url" target="_blank">
          <div class="image" :style="{'backgroundImage': 'url(' + ig.thumbnail + ')'}"></div>
        </a>
      </div>

    </div>

  </div>

</template>

<script>

export default {
  data () {
    return {
      instagrams: []
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      // if (process.env.NODE_ENV === 'production') {
      //   this.error = this.workshops = this.months = null
      //   this.$http.get('./static/instagram.json').then(response => {
      //     return response.json()
      //   }).then(json => {
      //     this.instagrams = json.instagrams
      //   }, response => {
      //     console.log('error')
      //   })
      // } else {
      //   let tt = require('../assets/data/instagram.json')
      //   console.log(tt)
      //   this.instagrams = tt.instagrams
      // }
      this.instagrams = [
        {
          'title': '',
          'thumbnail': '/static/Hato-Press-instagram1.jpg',
          'url': 'https://www.instagram.com/p/Bmp6Wu_j-iI/?tagged=hatopress'
        },
        {
          'title': '',
          'thumbnail': '/static/Hato-Press-instagram2.jpg',
          'url': 'https://www.instagram.com/p/BSMJD-EB4wv/?tagged=learnwithhato'
        },
        {
          'title': '',
          'thumbnail': '/static/Hato-Press-instagram3.jpg',
          'url': 'https://www.instagram.com/p/Boa_H7Tjll_/?tagged=hatopress'
        },
        {
          'title': '',
          'thumbnail': '/static/Hato-Press-instagram4.jpg',
          'url': 'https://www.instagram.com/p/BoB61rhBUs-/?tagged=hatopress'
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  text-align: center;
  background: #eee;
  background: rgb(221,253,242);
  margin: 0 0;
  padding: 2rem 0;
}
h2 {
  max-width: 600px;
}
.listings {
  max-width: 1200px;
  margin: 1rem auto;
  padding: 2rem 2rem 2rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.listing {
  width: 23%;
  margin-bottom: 3%;
  /*border-bottom: 1px solid rgba(0,0,0,0.1);*/
}
.listing a {
  display: block;
}
.image {
  width: 100%;
  padding-bottom: 100%;
  height: 0;
  /*border-radius: 50%;*/
  background: #f3f3f3;
  background-size: cover;
  background-position: center;
}
.info {
  margin-left: 2rem;
  margin-right: auto;
  color: #666;
}
.info h3 {
  max-width: 400px;
  font-weight: 500;
  margin-top: 0;
  color: #000;
}
.action a {
  display: block;
  font-size: .8em;
  padding: .6em 2.5em;
  border: 1px solid;
}

.filter {
  display: flex;
  justify-content: center;
}
.filter a {
  display: block;
  font-size: .8em;
  padding: .6em 2.5em;
  margin: 0 1em;
  /*border: 1px solid;*/
  background: #f3f3f3;
  color: #333;
  cursor: pointer;
}
.filter a:hover,
.filter a.active {
  background: #333;
  color: #f3f3f3;
}





@media screen and (max-width: 768px) {
}
@media screen and (max-width: 640px) {
  .listings {
    padding: 1rem 1rem 0;
  }
  .listing {
    width: 48%;
    margin-bottom: 4%;
  }
  .wrapper {
    /*padding: 1rem;*/
    padding: 1rem auto 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// Instagrams.vue?0cfbe22b